import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Table } from "./Table";
import { IPermissionProps } from "../../../models/Login";

export const SkillReport = (permissions: IPermissionProps) => {
    const toast = useRef<any>();
    return (
        <>
            <Table permissions={permissions} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}